import { AppButton, AppTextArea, AppTextField, AppMultiInputText } from 'components';
import { useEffect, useState } from 'react';
import Joi from 'joi';
import { checkForErrors } from 'utilities/fns';
import ModulesMultiSelect from 'components/molecules/ModulesMultiSelect';
function ManagePlan({ save, selectedItem = {}, handleSelectedItem }) {
  const [planName, handlePlanName] = useState('');
  const [planDescription, handlePlanDescription] = useState('');
  const [formErrors, setFormErrors] = useState([]);
  const [modules, setModules] = useState([]);
  const [highlights, setHighlights] = useState([]);

  useEffect(() => {
    if (selectedItem?._id) {
      handlePlanName(selectedItem?.name ?? '');
      handlePlanDescription(selectedItem?.description ?? '');
      if (Array.isArray(selectedItem?.highlights))
        setHighlights(selectedItem.highlights.map((x) => ({ value: x, label: x })));
      if (Array.isArray(selectedItem?.modules))
        setModules(selectedItem.modules.map((x) => ({ value: x.key, label: x.name })));
    }
  }, [selectedItem]);

  function handleSave() {
    setFormErrors([]);

    const data = {
      name: `${planName}`.trim(),
      description: `${planDescription}`.trim(),
      status: 'active',
      modules: modules.map((x) => x.value),
      highlights: highlights.map((x) => x.value),
    };

    const validation = managePlanSchema.validate(data, {
      abortEarly: false,
      allowUnknown: true,
    });

    if (validation?.error) {
      setFormErrors(validation.error?.details ?? []);
      return;
    }

    save?.({ ...data, id: selectedItem?._id });

    clearData();
  }

  function clearData() {
    setFormErrors([]);

    handlePlanName('');
    handlePlanDescription('');
    setModules([]);
    setHighlights([]);
    handleSelectedItem({});
  }

  const errors = checkForErrors(formErrors);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h2 className="prime-head p-0 boldtitle">Manage Plan</h2>
          {selectedItem?._id ? <span>Update Plan</span> : <span>Create a Plan</span>}
        </div>
        <div className="col-6 prime-head text-right"></div>
      </div>
      <div className="row mt-4">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <AppTextField
            labelProps={{
              label: 'Plan Name *',
              htmlFor: 'planName',
            }}
            inputProps={{
              placeholder: 'Plan Name *',
              id: 'planName',
              name: 'planName',
              value: planName,
              onChange: (event) => handlePlanName(event.target.value),
            }}
            fieldErrors={errors['planName']}
          />
        </div>
      </div>
      <div className="row my-4">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <AppTextArea
            label="Plan Description *"
            areaProps={{
              placeholder: 'Plan Description *',
              value: planDescription,
              onChange: (event) => {
                const description = event.target.value;
                handlePlanDescription(description);
              },
              rows: 10,
            }}
            fieldErrors={errors['planDescription']}
          />
        </div>
      </div>
      <div className="row my-4">
        <div className="col-12">
          <AppMultiInputText
            heading={'Highlight points'}
            value={highlights}
            setValue={(data) => setHighlights(data)}
          />
        </div>
      </div>
      <div className="row my-4">
        <div className="col-12">
          <ModulesMultiSelect
            enableAPI
            values={modules}
            handleChange={(data) => setModules(data)}
          />
        </div>
      </div>
      <div className="d-flex flex-row justify-content-center mt-4">
        <div className="d-flex">
          <AppButton
            variantClass="btn-primary mx-3"
            style={{ minWidth: '1.5rem' }}
            onClick={handleSave}
          >
            Save
          </AppButton>
          <AppButton variantClass="btn-plane p--tint mx-3" onClick={clearData}>
            Cancel
          </AppButton>
        </div>
      </div>
    </>
  );
}

const managePlanSchema = Joi.object({
  name: Joi.string().required().trim(),
  description: Joi.string().required().trim(),
  status: Joi.string().required(),
  modules: Joi.array().required(),
  highlights: Joi.array().required(),
});

ManagePlan.defaultProps = {
  save: () => {},
  handleSelectedItem: () => {},
};

export default ManagePlan;
